import { Unit } from '../../../units/models/unit';
import { UnitsActionsUnion } from '../actions/units.actions';
import { getUnitsFailure, getUnitsSuccess, updateUnitNameSuccess, UnitsApiActionsUnion } from '../actions/units-api.actions';
import * as UnitSharedActions from '../actions/units-shared.actions';
import * as UnitActions from '../actions/units.actions';


export interface State {
  units: Unit[] | null;
  areLoading: boolean;
}

export const initialState: State = {
  units: [],
  areLoading: false
};

export function reducer(
  state = initialState,
  action: UnitsActionsUnion | UnitsApiActionsUnion | UnitSharedActions.UnitsSharedActionsUnion
): State {
  switch (action.type) {
    case UnitActions.getUnits.type:
    case UnitSharedActions.getData.type: {
      return  {
        ...state,
        areLoading: true
      }
    }
    case getUnitsSuccess.type: {
      return {
        ...state,
        units: action.units,
        areLoading: false
      };
    }
    case getUnitsFailure.type: {
      return {
        ...state,
        units: null,
        areLoading: false
      };
    }
    case UnitSharedActions.clearData.type: {
      return {
        ...initialState
      };
    }
    case updateUnitNameSuccess.type: {
      const newUnits = [...state.units];
      const unitIndex = newUnits.findIndex(u => u?.unitId === action?.data?.unitId);
      if (unitIndex > -1) {
        newUnits[unitIndex] = action.data;
      }
      return {
        ...state,
        units: newUnits
      };
    }

    default: {
      return state;
    }
  }
}
export const getUnits = (state: State) => state.units;
export const getUnitsByIds = (state: State, unitIds: number[]) => state.units.filter(unit => unitIds.includes(unit.unitId));
export const areUnitsLoading = (state: State) => state.areLoading;
